/* import __COLOCATED_TEMPLATE__ from './team-selector.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { SearchableType } from 'embercom/models/data/inbox/searchable-types';

interface Arguments {
  excludedTeamIds?: Set<number>;
  [key: string]: any;
}

interface Signature {
  Args: Arguments;
  Element: HTMLElement;
  Blocks: {
    opener: [];
  };
}

export default class TeamSelector extends Component<Signature> {
  readonly teamEntity = SearchableType.Team;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::QuickSearch::TeamSelector': typeof TeamSelector;
    'inbox2/common/quick-search/team-selector': typeof TeamSelector;
  }
}
